import appoointmentReducer from "./appointmentReducer";
import sharedReducer from "./sharedReducer";

const rootReducer = () => ({
    shared: sharedReducer,
    appointment: appoointmentReducer
});

export default rootReducer;